import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M16.4 6.8v5.6H7.6m0-5.6v10.4" }, null, -1),
    _createElementVNode("circle", {
      cx: "7.6",
      cy: "4.4",
      r: "2.4"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "7.6",
      cy: "19.6",
      r: "2.4"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "16.4",
      cy: "4.4",
      r: "2.4"
    }, null, -1)
  ]))]))
}
export default { render: render }